export default {
  title: 'Username',
  informationsLabel: 'We recommend you to use an email address as username.',
};
